export default "__VITE_ASSET__D2X4ttCS__"